/* noms+ · Symptom-Explorer · assets/nplus-explorer.js
   Tabs mit einklappbarem Panel. Gleiche Bauart wie der Wirkkreis:
   ein Custom Element pro Section-Instanz, keine Abhängigkeiten. */

class NplusExplorer extends HTMLElement {
  connectedCallback() {
    if (!this.querySelector('[data-ex-panel]') && document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    if (this.ready) return;
    this.ready = true;

    this.tabs   = Array.from(this.querySelectorAll('[data-ex-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-ex-panel]'));
    if (!this.panels.length) return;

    this.index = this.dataset.openFirst === 'false' ? -1 : 0;

    // ------------------------------------------------------------
    // Wischen unter 900 px
    // ------------------------------------------------------------
    // Die Panels liegen dort in einem Scroll-Snap-Streifen. Beim
    // Wischen laeuft die Bubble-Leiste mit, beim Tippen auf eine
    // Bubble der Streifen - beide Richtungen synchron.
    // Im Wischmodus bleibt immer ein Thema offen: ein leerer
    // Streifen waere beim Wischen ein Loch.
    this.strip = this.querySelector('.np-ex__panels');
    this.tabstrip = this.querySelector('.np-ex__tabs');
    this.mq = window.matchMedia('(max-width: 900px)');
    this.swipe = this.mq.matches;
    if (this.swipe && this.index < 0) this.index = 0;
    this.mq.addEventListener('change', (e) => {
      this.swipe = e.matches;
      if (this.swipe && this.index < 0) this.index = 0;
      this.render();
      if (this.swipe) this.scrollToIndex(true);
    });

    if (this.strip) {
      let t;
      this.strip.addEventListener('scroll', () => {
        if (!this.swipe) return;
        clearTimeout(t);
        t = setTimeout(() => this.syncFromScroll(), 90);
      }, { passive: true });
    }

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const i = parseInt(tab.dataset.exTab, 10);
        // Erneuter Klick auf das aktive Thema klappt zu.
        this.select(i === this.index ? -1 : i);
      });
      tab.addEventListener('keydown', (e) => this.onKey(e));
    });

    this.render();
  }

  select(i) {
    // Im Wischmodus gibt es kein "alles zu" - sonst entsteht beim
    // Wischen ein Loch im Streifen.
    this.index = this.swipe && i < 0 ? this.index : i;
    this.render();
    if (this.swipe) this.scrollToIndex();
    this.centerTab();
  }

  scrollToIndex(instant) {
    if (!this.strip || !this.panels[this.index]) return;
    const el = this.panels[this.index];
    this.strip.scrollTo({
      left: el.offsetLeft - this.strip.offsetLeft,
      behavior: instant ? 'auto' : 'smooth'
    });
  }

  /** Die zugehoerige Bubble in die Sichtbarkeit holen. */
  centerTab() {
    const t = this.tabs[this.index];
    if (!t || !this.tabstrip) return;
    const left = t.offsetLeft - this.tabstrip.offsetLeft
               - (this.tabstrip.clientWidth - t.offsetWidth) / 2;
    this.tabstrip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  /** Nach dem Wischen: aktives Thema aus der Scrollposition ableiten. */
  syncFromScroll() {
    if (!this.strip) return;
    const mid = this.strip.scrollLeft + this.strip.clientWidth / 2;
    let best = 0, bestD = Infinity;
    this.panels.forEach((p, n) => {
      const c = p.offsetLeft - this.strip.offsetLeft + p.offsetWidth / 2;
      const d = Math.abs(c - mid);
      if (d < bestD) { bestD = d; best = n; }
    });
    if (best !== this.index) {
      this.index = best;
      this.render();
      this.centerTab();
    }
  }

  render() {
    // Im Wischmodus bleiben alle Panels sichtbar. hidden zu setzen und
    // sie trotzdem anzuzeigen waere fuer Screenreader widerspruechlich.
    this.panels.forEach((p, n) => { p.hidden = this.swipe ? false : n !== this.index; });
    this.tabs.forEach((t, n) => {
      const on = n === this.index;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      // Immer genau ein Tab in der Tab-Reihenfolge, sonst hangelt man
      // sich mit Tab durch alle Themen statt weiterzuspringen.
      t.setAttribute('tabindex', on || (this.index === -1 && n === 0) ? '0' : '-1');
    });
  }

  onKey(e) {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!step) return;
    e.preventDefault();
    const from = this.index === -1 ? 0 : this.index;
    const next = (from + step + this.tabs.length) % this.tabs.length;
    this.select(next);
    this.tabs[next].focus();
  }
}

if (!customElements.get('nplus-explorer')) {
  customElements.define('nplus-explorer', NplusExplorer);
}
